import React, { useContext } from "react";
import { LAText, LAView } from "../../components";
import { STRINGS } from "../../constant";
import { IMAGES } from "../../assets";
import { ThemeContext } from "../../context/ThemeProvider";

const CommunityPopup = ({ onCancle, communitySettings }) => {
  const { theme } = useContext(ThemeContext);
  return (
    <LAView
      type="full-element-center"
      className={`fixed top-0  left-0 right-0 bottom-0 bg-[${theme.MODAL_BACKGROUND_COLOR}] z-[600]`}
      styles={{ background: `${theme?.MODAL_BACKGROUND_COLOR}` }}
    >
      <LAView
        type="center"
        flex="col"
        className={`relative bg-[${theme.THEME_SCREEN_BACKGROUND_COLOR}] p-[24px] min-w-[25%] max-w-[40%] rounded-lg`}
        styles={{ background: `${theme?.THEME_SCREEN_BACKGROUND_COLOR}` }}
      >
        <button className="absolute right-[20px] top-[16px]" onClick={onCancle}>
          <img className="w-[16px] h-[16px]" src={IMAGES.ic_cancel} />
        </button>

        <svg
          stroke="currentColor"
          fill={`${communitySettings?.color}`}
          strokeWidth="0"
          viewBox="0 0 640 512"
          height="50px"
          width="50px"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"></path>
        </svg>
        {/* <img
          src={IMAGES?.community}
          className="sm:w-[50px] sm:h-[50px] md:w-[73px] md:h-[73px]"
        //   src={IMAGES.information}
        /> */}
        <h1
          className={`text-2xl text-[${theme?.THEME_TEXT_BLACK}] font-semibold pb-2 pt-2`}
        >
          {STRINGS.community_popup_title}{" "}
        </h1>

        <span className={`text-[${theme?.THEME_TEXT_GRAY}] text-sm pb-4`}>
          {STRINGS?.community_popup_desc}
        </span>

        <span
          className=" text-lg text-center"
          style={{ color: `${communitySettings?.color}` }}
        >
          {communitySettings?.message}
        </span>
        {/* {props?.options?.length > 0 && (
          <LAView className="w-full mt-4">
            {props?.options.map((e, index) => {
              return (
                <>
                  <LAButton
                    onPress={() => {
                      props.onPress(e, index);
                    }}
                    type={"simple"}
                    title={e}
                  />
                  {props?.options?.length - 1 != index && (
                    <LAView className="mt-3" />
                  )}
                </>
              );
            })}
          </LAView>
        )} */}
      </LAView>
    </LAView>
  );
};

export default CommunityPopup;
